import Vue from 'vue'
import {
    Radio,
    Backtop,
    Menu,
    MenuItem,
    Submenu,
    Icon,
    Select,
    Option,
    Table,
    Button,
    Form,
    FormItem,
    Tag,
    Input,
    Upload,
    Drawer,
    Skeleton,
    SkeletonItem,
    Pagination,
    Dialog,
    Notification,
    MessageBox,
    Message,

} from 'element-ui'

Vue.use(Radio); 
Vue.use(Backtop);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);
Vue.use(Icon);
Vue.use(Select);
Vue.use(Option);
Vue.use(Table);
Vue.use(Button); 
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tag);
Vue.use(Input);
Vue.use(Upload);
Vue.use(Drawer);
Vue.use(Skeleton); 
Vue.use(SkeletonItem);
Vue.use(Pagination);
Vue.use(Dialog);

Vue.prototype.$notify = Notification;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;